import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const locations = sqliteTable('locations', {
  id: text('id').notNull().primaryKey(),
  laravel_id: integer('laravel_id'),
  name: text('name').notNull(),
  user_id: integer('user_id'),
  is_sub_location: integer('is_sub_location'),
  is_enabled: integer('is_enabled'),
  organization_id: text('organization_id'),
  deleted_at: text('deleted_at'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
